import authService from './auth.service';
import assetService from './asset.service';
import groupService from './group.service';
import chatService from './chat.service';
import generationService from './generation.service';
import modelService from './model.service';
import { productService } from './product.service';
import orderService from './order.service';
import userService from './user.service';
import smsService from './sms.service';
import toolsService from './tools.service';
import editorService from './editor.service';
import giftService from './gift.service';
import versionService from './version.service';
import skillService from './skill.service';
import canvasAssetService from './canvasAsset.service';
import agreementService from './agreement.service';
import documentService from './document.service';
import teamService from './team.service';

export {
  authService,
  assetService,
  groupService,
  chatService,
  generationService,
  modelService,
  productService,
  orderService,
  userService,
  smsService,
  toolsService,
  editorService,
  giftService,
  versionService,
  skillService,
  canvasAssetService,
  agreementService,
  documentService,
  teamService,
};

/**
 * AMAI API服务
 *
 * 这些服务基于AMAI.openapi.json提供的接口定义，
 * 用于与AMAI后端API进行交互。
 */
export default {
  auth: authService,
  asset: assetService,
  group: groupService,
  chat: chatService,
  generation: generationService,
  model: modelService,
  product: productService,
  order: orderService,
  user: userService,
  sms: smsService,
  tools: toolsService,
  editor: editorService,
  gift: giftService,
  version: versionService,
  skill: skillService,
  agreement: agreementService,
  document: documentService,
  team: teamService,
};
